import React from "react";
import { Button } from "@heroui/react";
import { Icon } from "@iconify/react";
import { motion, AnimatePresence } from "framer-motion";

interface CookieConsentProps {
  show: boolean;
  onAccept: () => void;
}

export const CookieConsent: React.FC<CookieConsentProps> = ({ show, onAccept }) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-0"
        >
          <div className="mx-auto max-w-5xl bg-content2 border border-divider shadow-lg p-4 md:p-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <div className="flex items-start gap-3">
              <Icon icon="lucide:cookie" className="text-primary mt-1" width={24} />
              <div>
                <h3 className="font-medium mb-1">Мы используем файлы cookie</h3>
                <p className="text-sm text-foreground/70">
                  Файлы cookie помогают нам улучшить работу сайта и персонализировать контент. Продолжая использовать сайт, вы соглашаетесь с нашей{" "}
                  <a href="/privacy" className="text-primary hover:underline">
                    политикой конфиденциальности
                  </a>.
                </p>
              </div>
            </div>
            <Button 
              color="primary" 
              className="whitespace-nowrap shrink-0"
              onPress={onAccept}
            >
              Принять все cookie
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};